/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react';
import {Row, Col, Box, Button, Pagination} from 'adminlte-2-react';
import Loader from '../../utils/Loader';
import {Alert} from '../../ui/alert';
import {submitSearchOnEnterPress} from '../../utils/utils';
import {TextInput} from '../../utils/TextInput';
import {EmCandidatosTable} from './EmCandidatosTable';
import {useWindowSize} from '../../utils/useWindowSize';
import {ModalGenerico} from '../../ui/ModalGenerico';
import {ModalEmCandidatoEdit} from './ModalEmCandidatoEdit';
import {ModalNotasV2} from '../../candidatos/ModalNotasV2';
import {ModalExportar} from './ModalExportar';
import {Content} from '../../ui/Content';
import {SelectRubros} from './SelectRubros';
import {SelectInput} from '../../utils/SelectInput';

function ListaEmCandidatosView({
  history,
  topAlert,
  submitAlert,
  totalResults,
  page,
  pageSize,
  handlePage,
  refetchCandidatos,
  busquedaRapida,
  setBusquedaRapida,
  emCandidatosGet,
  groupedCandidates,
  emCandidatoDelete,
  deleteEmCandidato,
  selectedCandidato,
  setSelectedCandidato,
  candidatoSelectedForEdit,
  setCandidatoSelectedForEdit,
  emCandidatoEdit,
  editEmCandidato,
  parametroOption,
  parametroOptions,
  setParametroOption,
  condicionesActuales,
  setCondicionesActuales,
  condicionesContratacion,
  setCondicionesContratacion,
  resumen,
  setResumen,
  candidatoIdNumerico,
  isModalNotasShown,
  hideModalNotas,
  showModalNotas,
  userIdNumerico,
  setExpectativaSalarial,
  setCandidatoIdNumerico,
  notaFavorita,
  notaFavoritaGet,
  token,
  estudioMercadoIdNumerico,
  queryParams,
  getNotaFavorita,
  rubroOption,
  setRubroOption,
  filtroParametroOption,
  setFiltroParametroOption,
}) {
  const {isMobile} = useWindowSize();
  const [testMostrarModal, setTestMostrarModal] = useState(false);
  const [isModalExportarShown, setIsModalExportarShown] = useState(false);

  // Por el momento no se puede filtrar por 'Sin especificar'
  const filtroParametroOptions = parametroOptions.filter(elem => !!elem.value);

  return (
    <Content title="EM - Candidatos" history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      {selectedCandidato && (
        <ModalGenerico
          isModalShown={!!selectedCandidato}
          hideModal={() => setSelectedCandidato(null)}
          title="Eliminar"
          body="Se eliminará el candidato. ¿Continuar?"
          buttonText="Eliminar"
          buttonType="danger"
          buttonDisabled={emCandidatoDelete.loading}
          buttonLoading={emCandidatoDelete.loading}
          submit={() => deleteEmCandidato(selectedCandidato)}
        />
      )}

      <ModalNotasV2
        isModalShown={isModalNotasShown}
        hideModal={hideModalNotas}
        showModal={showModalNotas}
        handlePage={refetchCandidatos}
        page={page}
        getNotaFavorita={getNotaFavorita}
        userIdNumerico={userIdNumerico}
        candidatoIdNumerico={candidatoIdNumerico}
        token={token}
      />

      {candidatoSelectedForEdit && (
        <ModalEmCandidatoEdit
          isModalShown={!!candidatoSelectedForEdit}
          title="Editar candidato"
          emCandidatoEdit={emCandidatoEdit}
          editEmCandidato={editEmCandidato}
          parametroOption={parametroOption}
          parametroOptions={parametroOptions}
          setParametroOption={setParametroOption}
          condicionesActuales={condicionesActuales}
          setCondicionesActuales={setCondicionesActuales}
          condicionesContratacion={condicionesContratacion}
          setCondicionesContratacion={setCondicionesContratacion}
          resumen={resumen}
          setResumen={setResumen}
          candidatoSelectedForEdit={candidatoSelectedForEdit}
          setCandidatoSelectedForEdit={setCandidatoSelectedForEdit}
          testMostrarModal={testMostrarModal}
          setTestMostrarModal={setTestMostrarModal}
          setCandidatoIdNumerico={setCandidatoIdNumerico}
          setExpectativaSalarial={setExpectativaSalarial}
          notaFavorita={notaFavorita}
          notaFavoritaGet={notaFavoritaGet}
          showModalNotas={showModalNotas}
        />
      )}

      {isModalExportarShown && (
        <ModalExportar
          token={token}
          estudioMercadoIdNumerico={estudioMercadoIdNumerico}
          isModalShown={isModalExportarShown}
          hideModal={() => setIsModalExportarShown(false)}
        />
      )}

      <Loader isLoading={emCandidatosGet.loading}>
        <div style={{}}>
          <Box
            footer={
              <>
                <Button
                  type="primary"
                  text="Filtrar"
                  onClick={() => handlePage(1)}
                />
              </>
            }>
            <div style={{display: 'flex', gap: 10, flexWrap: 'wrap'}}>
              <div style={{minWidth: 250}}>
                <TextInput
                  label="Búsqueda rápida"
                  placeholder=""
                  initialValue={busquedaRapida}
                  setValue={setBusquedaRapida}
                  onKeyDown={event =>
                    submitSearchOnEnterPress(event, () => handlePage(1))
                  }
                />
              </div>

              <div style={{minWidth: 250}}>
                <SelectRubros
                  rubroOption={rubroOption}
                  setRubroOption={setRubroOption}
                  token={token}
                />
              </div>

              <div style={{minWidth: 250}}>
                <SelectInput
                  label="Parámetro"
                  value={filtroParametroOption}
                  options={filtroParametroOptions}
                  setValue={setFiltroParametroOption}
                  isMulti
                />
              </div>
            </div>
          </Box>
        </div>

        <Row>
          <Col xs="12" sm="12" lg="12">
            <Box
              title="Lista"
              customOptions={
                <div style={{display: 'flex'}}>
                  {/* <form
                    method="POST"
                    action="http://localhost:4000/v1/estudio/candidatos/export/pdf"
                  >
                    <button type="submit">Exportar a PDF</button>
                  </form> */}

                  <div style={{marginRight: 10}}>
                    <Button
                      type="default"
                      size="sm"
                      text="Incluir candidato"
                      onClick={() => {
                        const params = {
                          estudioMercadoIdNumerico,
                          queryParams,
                        };
                        localStorage.setItem(
                          'emParams',
                          JSON.stringify(params),
                        );
                        history.push('/candidatos');
                      }}
                    />
                  </div>

                  <div>
                    <Button
                      type="default"
                      size="sm"
                      text="Exportar"
                      onClick={() => {
                        setIsModalExportarShown(true);
                      }}
                    />
                  </div>
                </div>
              }>
              <div style={{display: 'block'}}>
                <span>Total: {totalResults}</span>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  justifyContent: 'space-between',
                }}>
                <div>
                  {pageSize && (
                    <Pagination
                      activePage={page - 1}
                      pageSize={pageSize}
                      totalElements={totalResults}
                      onChange={page => handlePage(page + 1)}
                      labels={{
                        first: 'Primera',
                        last: 'Última',
                        previous: 'Anterior',
                        next: 'Siguiente',
                      }}
                    />
                  )}
                </div>
              </div>

              <EmCandidatosTable
                emCandidatosGet={emCandidatosGet}
                groupedCandidates={groupedCandidates}
                setSelectedCandidato={setSelectedCandidato}
                setCandidatoSelectedForEdit={setCandidatoSelectedForEdit}
              />

              {pageSize && (
                <Pagination
                  activePage={page - 1}
                  pageSize={pageSize}
                  totalElements={totalResults}
                  onChange={page => handlePage(page + 1)}
                  labels={{
                    first: 'Primera',
                    last: 'Última',
                    previous: 'Anterior',
                    next: 'Siguiente',
                  }}
                />
              )}

              <div>
                <span>Total: {totalResults}</span>
              </div>

              {submitAlert.text && (
                <Alert
                  title={submitAlert.title}
                  type={submitAlert.type}
                  text={submitAlert.text}
                  closable={submitAlert.closable}
                />
              )}
            </Box>
          </Col>
        </Row>
      </Loader>
    </Content>
  );
}

export {ListaEmCandidatosView};
